import { render, staticRenderFns } from "./CustomerBalanceReport.vue?vue&type=template&id=0cd06eca&scoped=true&"
import script from "./CustomerBalanceReport.vue?vue&type=script&lang=js&"
export * from "./CustomerBalanceReport.vue?vue&type=script&lang=js&"
import style0 from "./CustomerBalanceReport.vue?vue&type=style&index=0&id=0cd06eca&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cd06eca",
  null
  
)

export default component.exports